<div id="ct-parameter-heading" class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Parametrierung Trinkwasser"}}</h4>
</div>
<div class="modal-body">
	<div id="js-parameter-region"></div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal"> {{TR "Abbrechen"}} </button>
	</button><button id="js-save" class="btn btn-primary">{{TR "Speichern"}}</button>
</div>
